<template>
  <div>
    <div class="header">
      <h2>Order History</h2>
    </div>
    <div class="description">
      Review your order history below and reorder as needed.
    </div>
    <BBDataTable
      class="orderHistoryContainer"
      :columns="columns"
      :support-add-new="false"
      path-url-api="orders"
      :default-api-params="{
        _view: 'orderHistory',
        _fields:
          'orderNumber,createdAt,currentStatus.name,currentStatus.status,reorderChild,isReorder,cannotReorder,showReorder',
        _fieldsNoPopulate:
          'design._id,design.estimationData.orderSummary,design.name,design.thumbnailSmallCenterPath,design.userObj,' +
          'design.product.productCategory.name,design.bodyColor,design.quantity,design.product.gender.name',
        _sort: 'createdAt',
        _order: 'desc',
        _filter: [
          {
            field: 'isDeleted',
            op: '=',
            val: 'false'
          },
          {
            field: 'user',
            op: '=',
            val: userId
          },
          {
            field: 'currentStatus',
            op: 'in',
            val: [
              this.orderStatusOrderOrderInProgress,
              this.orderStatusOrderOrderShipped,
              this.orderStatusOrderOrderLegacy,
              this.orderStatusOrderOrderCancelled
            ]
          }
        ]
      }"
    >
      <template v-slot:customCell="{ props }">
        <div v-if="props.column.field == 'orderNumber'" class="orderNumberCell">
          <div class="boldText">
            {{ formatOrderNumber(props.row.orderNumber) }}
          </div>
          <div class="imgSubmission">
            <b-img-lazy
              :src="props.row.design.thumbnailSmallCenterPath"
              v-if="props.row.design.thumbnailSmallCenterPath"
              v-bind="imgSubmission"
            />
            <span v-else>No image</span>
          </div>
        </div>
        <div
          v-else-if="props.column.field == 'designquantity'"
          class="orderNumberCell"
        >
          {{ orderQuantity(props.row.design) }}
        </div>
        <div
          v-else-if="props.column.field == 'currentStatus'"
          class="currentStatusCell"
        >
          <div class="boldText">
            <div v-if="[8].includes(props.row.currentStatus.status)">
              In Progress
            </div>
            <div v-else-if="[9].includes(props.row.currentStatus.status)">
              Shipped
            </div>
            <div v-else-if="[0].includes(props.row.currentStatus.status)">
              Cancelled
            </div>
          </div>
        </div>
        <div v-else>
          {{ props.formattedRow[props.column.field] }}
        </div>
      </template>
      <template v-slot:customButtons="slotProps">
        <div class="flex-column align-bottom">
          <router-link
            :to="{
              name: 'orderReview',
              params: {
                id: slotProps.props.row.design._id,
                orderId: slotProps.props.row._id
              }
            }"
            class="btn btn-link btn-highlight btn-sm ml-1"
            v-if="slotProps.props.row"
          >
            <font-awesome-icon class="mr-2" :icon="icons.faEye" />
            <span class="bb-label">
              View
            </span>
          </router-link>

          <button
            class="btn btn-link btn-highlight btn-sm btn-block ml-1 mt-0"
            v-if="enableReorder(slotProps.props.row)"
            @click="validateReorder(slotProps.props.row)"
          >
            <font-awesome-icon class="mr-2" :icon="icons.faPencilAlt" />
            <span class="bb-label">
              Reorder
            </span>
          </button>
        </div>
      </template>
    </BBDataTable>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { faEye, faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import UserService from '@/services/UserService'

const oauthStore = namespace('oauthStore')
const userStore = namespace('userStore')
const organizationStore = namespace('organizationStore')

@Component({
  components: {}
})
export default class OrderHistory extends Vue {
  @oauthStore.Getter('userId') userId
  @userStore.Action('setIsReorder') actionSetIsReorder
  @organizationStore.Action('fetchItem') actionFetchOrganization

  icons = {
    faPencilAlt,
    faEye: faEye
  }

   validateReorder(order) {
    let organizationId
    UserService.getItem(this.getterUserId)
      .then((res) => {
        organizationId = res.data.organization
      })
      .then(() => {
        return this.actionFetchOrganization({
          id: organizationId,
          config: {
            params: {
              _fields:
                'organizationName,isActive,dealerOrganization.isActive,dealerOrganization.organizationName',
            },
          },
        }).then((org) => {
          console.log('org', org)
          if (org.isActive) {
            if (org.dealerOrganization.isActive) {
              this.actionSetDesignId(order.design.id)
              if (order.reorderChild) {
                this.actionSetOrderId(order.reorderChild._id)
                this.actionSetIsReorder(true)
                this.$router.push({
                  name: 'rosterfrontorder',
                  params: {
                    id: order.design._id,
                    orderId: order.reorderChild._id,
                  },
                })
              } else {
                this.generateReorder(order).then((order) => {
                  this.actionSetOrderId(order.data._id)
                  this.actionSetIsReorder(order.data.isReorder)
                  this.$router.push({
                    name: 'rosterfrontorder',
                    params: {
                      id: order.data.design._id,
                      orderId: order.data._id,
                    },
                  })
                })
              }
            } else {
              this.alertUnavailableReorder(
                org.dealerOrganization.organizationName,
                'account'
              )
            }
          } else {
            this.alertUnavailableReorder(org.organizationName, 'organization')
          }
        })
      })
  }

  orderQuantity(designData) {
    let qty = 0

    qty +=
      (designData.estimationData &&
        designData.estimationData.orderSummary &&
        designData.estimationData.orderSummary.main &&
        designData.estimationData.orderSummary.main.totalQty) ||
      0
    qty +=
      (designData.estimationData &&
        designData.estimationData.orderSummary &&
        designData.estimationData.orderSummary.pair &&
        designData.estimationData.orderSummary.pair.totalQty) ||
      0
    return qty
  }

  get columns() {
    return [
      {
        label: 'ID',
        field: '_id',
        hidden: true
      },
      {
        label: 'Submission',
        field: 'orderNumber',
        type: 'customCell',
        filterOptions: {
          enabled: true, // enable filter for this column
          placeholder: 'Filter by Order Number', // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          operator: '=',
          trigger: 'keyup' // only trigger on enter not on keyup
        }
      },
      {
        label: 'Design Name',
        field: 'design.name',
        filterOptions: {
          enabled: true,
          operator: 'like'
        }
      },
      {
        label: 'Sport',
        field: 'design.product.productCategory.name'
      },
      {
        label: 'Color',
        field: 'design.bodyColor.name'
      },
      {
        label: 'Date',
        field: 'createdAt',
        type: 'date',
        dateInputFormat: 'YYYY-MM-DDTHH:mm:ss.SSS', // expects 2018-03-16T05:29:18.123
        dateOutputFormat: 'MM/DD/YYYY'
      },
      {
        label: 'Qty',
        field: 'designquantity',
        type: 'customCell'
      },
      {
        label: 'Gender',
        field: 'design.product.gender.name'
      },
      {
        label: 'Status',
        field: 'currentStatus',
        type: 'customCell'
      },
      {
        label: 'Actions',
        field: 'actions'
      }
    ]
  }

  imgSubmission = {
    center: true,
    blank: true,
    blankColor: '#bbb',
    height: 50
  }
}
</script>

<style lang="scss" scoped>
.orderNumberCell {
  align-items: center;
  display: flex;
  .imgSubmission {
    text-align: center;
    width: 100%;
  }
}
.orderHistoryContainer {
  /deep/ {
    table.vgt-table tbody tr td {
      vertical-align: middle;
    }
    .orderHistoryAction {
      text-align: center;
    }
  }
}
</style>
